
import { Component, namespace, Prop, Vue } from "nuxt-property-decorator";

const FederalStatesModule = namespace("federalstates");

@Component({})
export default class DistrictPriceInfo extends Vue {
  @Prop({ required: true }) isDistrictCity!: boolean;
  @Prop({ required: true })
  readonly currentAverageCountyPrice!: string;
  @Prop({ required: true }) priceComparisonText!: string;
  @Prop({ required: true })
  priceComparisonText7Days!: string;
  @Prop({ type: Object, required: true })
  countyYearPriceStatisctics!: any;
  @Prop({ required: true })
  lastPriceDifferenceText!: string;

  @FederalStatesModule.State("countyName")
  countyName;

  get headerText(): string {
    const prefix = this.isDistrictCity
      ? "in der kreisfreien Stadt"
      : "im Landkreis";
    return `Was kostet Heizöl ${prefix} ${this.countyName}?`;
  }
}
